import React from 'react';
import { arrivalLineColor } from '../../../constants/colors';
import AdmIntervalChartWrapper from '../adm_shared/AdmIntervalChartWrapper';

export default function AdmArrivalIntervalChart(props) {
  const { arrival, increment, d0_interval, d2_interval } = props;

  return (
    <AdmIntervalChartWrapper
      title='Defect Arrival Prediction'
      arrival={arrival}
      increment={increment}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
      arrivalColor={arrivalLineColor}
      showArrival={true}
      showClosure={false}
    />
  );
}
